import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import restClient from '../../../routers/MainFrame/action/APIClient';

var GetEditNotificationsAction = function () {

}

GetEditNotificationsAction.prototype = {

	getEditNotifications: function (data) {
		restClient.getEditNotifications(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				AppDispatcher.dispatch({
					actionType: Constant.EDIT_NOTIFICATIONS,
					data: error
				});
			} else if(response != null) {
				response['status'] = 200;
				AppDispatcher.dispatch({
					actionType: Constant.EDIT_NOTIFICATIONS,
					data: response
				});
			}
		})
	}
}

export default new GetEditNotificationsAction();